import { z } from 'zod';
import { CareDocumentDataSchema } from './CareDocumentDataSchema';
import { IObject } from '../../IObject';
import { dateValidation } from '../../../validation';

export const AvivaCareDocumentDataSchema = CareDocumentDataSchema.extend({
  sentToCaseManager: z
    .object({
      at: dateValidation(),
      by: z.string().nullish(),
      // whether the member was CC'd (PPL-3293); absent on stamps written
      // before the CC option existed
      ccMember: z.boolean().optional(),
    })
    .optional(),
  // Return to Work Plan only — emailed to the employer contact captured on
  // the Aviva referral (PPL-3293)
  sentToEmployer: z
    .object({
      at: dateValidation(),
      by: z.string().nullish(),
      // always true today (the member is CC'd unconditionally), stored so
      // the record stays accurate if that policy ever changes
      ccMember: z.boolean().optional(),
    })
    .optional(),
});

export type AvivaCareDocumentData = z.infer<typeof AvivaCareDocumentDataSchema>;
export type AvivaCareDocument = IObject.HasIdTimestamped<AvivaCareDocumentData>;
